import I18n from "i18n-js";
import React, { Component } from "react";
import { bool, number, oneOf, oneOfType, string } from "prop-types";
import { formatFloat } from "../../utils/formatUtils";

export default class Quantity extends Component {
  static propTypes = {
    value: oneOfType([number, string]),
    unit: oneOf(["kg", "L", "CO2"]),
    className: string,
    displayNullAsZero: bool,
  };

  static defaultProps = {
    value: 0,
    unit: "kg",
    className: "",
    displayNullAsZero: true,
  };

  /**
   * {@inheritdoc}
   */
  render() {
    const { value, unit, className, displayNullAsZero } = this.props;

    let formattedValue = formatFloat(value || 0);
    let formattedUnit = " " + I18n.t(`common.quantity.unit:${unit}`);
    if (!displayNullAsZero && typeof value !== "number") {
      formattedValue = "-";
      formattedUnit = "";
    }

    return (
      <div
        className={`quantity ${className}`}
        data-unit={formattedUnit}
      >
        {formattedValue}
      </div>
    );
  }
}
